import { TokenConstants } from '../types';

// The GIWA build must set the VITE_UNDERLYING_*_TOKEN_ADDRESS vars explicitly:
// the Sepolia BTC-side fallback in config.service.ts (0x8af6...46fA) is the
// same address as GIWA's rETH (same deployer nonce, different chain), so the
// fallback silently maps the wrong token.
const tokens: TokenConstants = {
  Popular: {
    Symbols: ['WBTC', 'DAI', 'USDC', 'BAL', 'USDT', 'WETH'],
  },
  InitialSwapTokens: {
    input: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
    output: '0x8af61F025562cE808c3066dC990450Ea546246fA',
  },
  Addresses: {
    nativeAsset: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
    wNativeAsset: '0x4200000000000000000000000000000000000006',
    WETH: '0x4200000000000000000000000000000000000006',
    BAL: '',
  },
};

export default tokens;
